var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextIcon = function SvgTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.149 18v-.74l1.994-.36-.275.378V6.79l.31.258H7.86l.343-.293L7.86 8.94H7V6h9.129v2.94h-.86l-.344-2.15.344.259h-3.318l.31-.258v10.487l-.258-.378 1.977.36V18z"
  })));
};
export default SvgTextIcon;